import { useTranslation } from 'next-i18next';
import Skeleton from 'react-loading-skeleton';

import styles from './ProductCompareTable.module.scss';

const SKELETON_COLS = 4;
const SKELETON_ROWS = 4;

const LoadingSkeleton = () => {
  const { t } = useTranslation('comparison');

  return (
    <div className={styles.container}>
      <div className={styles.scrollWrapper}>
        <table className={styles.table} aria-label={t('title')} role="grid">
          <caption className={styles.srOnly}>{t('title')}</caption>
          <colgroup>
            <col className={styles.labelCol} />
            {Array.from({ length: SKELETON_COLS }).map((_, i) => (
              <col key={i} className={styles.productCol} />
            ))}
          </colgroup>
          <thead>
            <tr>
              <th scope="col" className={styles.labelCell} />
              {Array.from({ length: SKELETON_COLS }).map((_, i) => (
                <th key={i} scope="col" className={styles.productHeaderCell}>
                  <Skeleton height={304} />
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {Array.from({ length: SKELETON_ROWS }).map((_row, r) => (
              <tr key={r}>
                <th scope="row" className={styles.labelCell}>
                  <Skeleton height={16} width={80} />
                </th>
                {Array.from({ length: SKELETON_COLS }).map((_col, c) => (
                  <td
                    key={c}
                    className={styles.dataCell}
                    tabIndex={0}
                    role="gridcell"
                  >
                    <Skeleton height={16} />
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default LoadingSkeleton;
